import React from 'react';

// Styles & Assets
import styles from './ScoreCircle.module.css';
import { MdArrowDropUp, MdArrowDropDown, MdRemove } from 'react-icons/md';
import { TiEquals } from 'react-icons/ti';


// Services
import { findMatchingRule } from '../../../services/Scores';

// Interfaces
import { IScoreRule } from '../../../interfaces/Score';

const ScoreCircle: React.FC<{
    rules: IScoreRule[]
    lastScore: number | undefined,
    secondLastScore: number | undefined,
}> = ({ rules, lastScore, secondLastScore }) => {

    const matchRule = findMatchingRule(rules, lastScore);

    const getVariation = () => {
        if (secondLastScore === undefined || lastScore === undefined) return null;
        else if (secondLastScore === lastScore) return { colorClass: styles.equal, Icon: TiEquals };
        else if (secondLastScore > lastScore) return { colorClass: styles.arrowUp, Icon: MdArrowDropUp };
        else return { colorClass: styles.arrowDown, Icon: MdArrowDropDown };
    };

    const variance = getVariation();
    
    return (
        <div className={styles.cvContainer}>
            {matchRule !== null ?
                <div
                    className={styles.circleIcon}
                    style={{ backgroundColor: matchRule.color_alert || undefined }}
                />
                : <div className={`${styles.status} ${styles.remove}`}>
                    <MdRemove />
                </div>
            }
            {variance === null ? null :
                <div className={`${styles.status} ${variance.colorClass}`}>
                    {variance.Icon && <variance.Icon />}
                </div>
            }
        </div>
    );
};

export default ScoreCircle;